import { styled, chipClasses } from '@mui/material';
import { FalconAvatar } from '@procureai/ui-mui';

export const AvatarStyled = styled(FalconAvatar)(({ theme }) => ({
  [`.${chipClasses.avatar}&`]: {
    color: theme.palette.background.paper,
  },
  backgroundColor: theme.palette.text.secondary,
})) as typeof FalconAvatar;
